import { ApiRequest, ShowLoader } from 'GlobalFunctions';
import { useEffect, useState } from 'react';
import Coupons from '../Orders/Coupons';
import getOrderDetails from '../Orders/getOrderDetails';

export default function Cart() {

    const [cart, setCart] = useState<any>(null);
    // useEffect(() => {
    //     getCart()
    // }, []);

    const [summary, setSummary] = useState<any>({});

    const getCart = async () => {
        const cart = await getOrderDetails("cart");
        ShowLoader(false);
    }

    useEffect(() => {
        getCart();
        const checkout_button = document.querySelector('[pc="view-checkout"]');
        if (checkout_button) {
            checkout_button.addEventListener("click", async (e) => {
                // Get webflow pages from storeConfiguration in localStorage
                let checkoutUrl = '/pennicart-checkout'; // default
                
                try {
                    const storeConfigStr = localStorage.getItem('storeConfiguration');
                    if (storeConfigStr) {
                        const storeConfig = JSON.parse(storeConfigStr);
                        const webflowPages = storeConfig?.data?.store?.webflow_pages;
                        
                        if (webflowPages && webflowPages.checkout) {
                            checkoutUrl = '/' + webflowPages.checkout;
                        }
                    }
                } catch (error) {
                    console.error('Error reading storeConfiguration from localStorage:', error);
                }
                
                window.location.href = checkoutUrl;
            }
            )
        }
    }, []);




    return (
        <>

            <Coupons
                summary={summary}
                page="cart"
            />
        </>
    )
}

